import Alert from './src/main';

Alert.install = function(Vue) {
  Vue.component(Alert.name, Alert);
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/alert/index.js